import React from 'react'
import { useModelValue } from '@morningtrain/react-resources'
import { ShiftBadge } from 'ui/elements'

function SlotBadge ({ gray, big = false }) {
  const title = useModelValue('title')
  const slug = useModelValue('enum')

  return <ShiftBadge title={title} slug={slug} gray={gray} big={big} />
}

SlotBadge.defaultProps = {
  gray: false
}

export default SlotBadge
